import { render, staticRenderFns } from "./funcao.vue?vue&type=template&id=281b6a56"
import script from "./funcao.vue?vue&type=script&lang=js"
export * from "./funcao.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports